import { environment } from './../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DownloadDocumentPayload } from '../../models/document-management/document-management.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentManagementService {
  private readonly documentManagementAPI: string;
  constructor(private readonly http: HttpClient) {
    this.documentManagementAPI = environment.documentManagementAPI;
  }

  bulkUploadDocument(files: File[], path: string, createUniqueName: boolean = true, overwrite: boolean = false): Observable<any> {
    const formData = new FormData();

    // Append files to FormData
    files.forEach(file => formData.append('Files', file));

    formData.append('CreateUniqueName', createUniqueName ? 'true' : 'false');
    formData.append('OverWrite', overwrite ? 'true' : 'false'); 
    formData.append('Path', path);
    return this.http.post(`${this.documentManagementAPI}DocumentManagement/BulkUpload`, formData, {})
  }

  downloadDocument(downloadDocumentPayload: DownloadDocumentPayload): Observable<any> {
    return this.http.post(`${this.documentManagementAPI}DocumentManagement/Download`, downloadDocumentPayload, {})
  }

  downloadBulkDocuments(downloadBulkDocumentPayload: DownloadDocumentPayload[]): Observable<any> {
    return this.http.post(`${this.documentManagementAPI}DocumentManagement/BulkDownload`,downloadBulkDocumentPayload, {})
  }

  deleteDocument(id: number): Observable<any> {
    return this.http.delete(`${this.documentManagementAPI}DocumentManagement/${id}`)
  }
}